var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1025 1024",
    style: {
      enableBackground: "new 0 0 1025 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.5,928.1v-576c0-35.4-28.7-64-64-64h-128c-35.3,0-64,28.6-64,64v576c0,35.4,28.7,64,64,64h128 C291.8,992.1,320.5,963.5,320.5,928.1z M128.5,480.1v-128h128v128H128.5z M128.5,736.1v-192h128v192H128.5z M128.5,928.1v-128h128 v128H128.5z M512.5,352.1v576c0,35.4,28.7,64,64,64h320c35.4,0,64-28.6,64-64v-576c0-35.4-28.6-64-64-64h-320 C541.2,288.1,512.5,316.7,512.5,352.1z M896.5,800.1v128h-128v-128H896.5z M704.5,800.1v128h-128v-128H704.5z M896.5,544.1v192h-128 v-192H896.5z M704.5,544.1v192h-128v-192H704.5z M896.5,352.1v128h-128v-128H896.5z M704.5,352.1v128h-128v-128H704.5z M263.9,100.2 l112.5,168.2c18.6,27.8,61.8,27.8,80.4,0l112.5-168.2c19.8-29.7-2.8-68.3-40.2-68.3h-225C266.7,31.9,244,70.6,263.9,100.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableColumn);
export default __webpack_public_path__ + "static/media/table-column.ca50873fbc69d4fee8447aa4daf4079f.svg";
export { ForwardRef as ReactComponent };